import axios from 'axios';

const API_URL = '/api/auth/';

function decodeJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4) payload += '='; // padding
    const json = atob(payload);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

const register = (username, email, password) => {
  return axios.post(API_URL + 'register', { username, email, password });
};

const login = async (email, password) => {
  const response = await axios.post(API_URL + 'login', { email, password });
  if (response.data.token) {
    const decoded = decodeJwt(response.data.token);
    const role = decoded?.user?.role || null;
    const toStore = { ...response.data, role };
    // backend now returns username + email
    if (response.data.username) toStore.username = response.data.username;
    if (response.data.email) toStore.email = response.data.email;
    if (response.data.first_name) toStore.first_name = response.data.first_name;
    if (response.data.last_name) toStore.last_name = response.data.last_name;
    else toStore.email = email;
    localStorage.setItem('user', JSON.stringify(toStore));
  }
  return response.data;
};

const logout = async () => {
  const stored = getCurrentUser();
  try {
    if (stored?.token) {
      await axios.post(API_URL + 'logout', {}, { headers: { 'x-auth-token': stored.token } });
    }
  } catch(e){ /* ignore network errors */ }
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const fetchProfile = async () => {
  const stored = getCurrentUser();
  if (!stored?.token) return null;
  try {
    const res = await axios.get(API_URL, { headers: { 'x-auth-token': stored.token } });
    // server returns role_name now
    if (res.data) {
      const merged = {
        ...stored,
        role: res.data.role_name || stored.role,
        username: res.data.username || stored.username,
        email: res.data.email || stored.email,
        first_name: res.data.first_name || stored.first_name,
        last_name: res.data.last_name || stored.last_name,
      };
      localStorage.setItem('user', JSON.stringify(merged));
      return merged;
    }
    return stored;
  } catch (e) {
    return stored; // keep old
  }
};

const authService = {
  register,
  login,
  logout,
  getCurrentUser,
  fetchProfile,
  decodeJwt,
};

export default authService;
